import React from 'react';
import { Reveal } from './Reveal';
import { QuoteIcon, StarIcon } from './icons/Icons';
const testimonials = [{
  quote: 'Pensé que nunca volvería a tomar café. En 3 días con el protocolo de la sábila y la col, el ardor desapareció al 90%. Es increíble.',
  name: 'Elena R.',
  location: 'Ciudad de México',
  initials: 'ER'
}, {
  quote: 'Gasté cientos de dólares en gastroenterólogos. Este ebook de 11 dólares hizo más por mí que todas las citas médicas juntas. Ya duermo plano, sin reflujo.',
  name: 'Ricardo M.',
  location: 'Madrid',
  initials: 'RM'
}, {
  quote: 'Llevaba años con reflujo cada noche. A la semana del protocolo dejé de despertarme ahogada. Volví a comer sin ese nudo de miedo en el estómago.',
  name: 'Carmen G.',
  location: 'Bogotá',
  initials: 'CG'
}, {
  quote: 'Soy escéptico por naturaleza, pero los batidos de emergencia me salvaron en un ataque agudo a media reunión. En minutos el ardor bajó muchísimo.',
  name: 'Andrés P.',
  location: 'Buenos Aires',
  initials: 'AP'
}, {
  quote: 'La lista de compras “Antifuego” me cambió el súper. Dejé de gastar en antiácidos y ahora sé exactamente qué llevar. Mi digestión es otra en 3 semanas.',
  name: 'Lucía F.',
  location: 'Lima',
  initials: 'LF'
}, {
  quote: 'Tenía H. Pylori y mi doctor me felicitó por lo rápido que mejoró mi mucosa. El desayuno sin acidez es lo que más me costaba y ahora lo disfruto.',
  name: 'Miguel A.',
  location: 'Guadalajara',
  initials: 'MA'
}];
export function Testimonials() {
  return <section className="w-full bg-[#f7f4ec] py-16 sm:py-20" data-id="element-246">
      <div className="mx-auto max-w-5xl px-5" data-id="element-247">
        <Reveal data-id="element-248">
          <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-[#3f6b3a]" data-id="element-249">
            Prueba Social
          </p>
          <h2 className="mt-2 text-center font-display text-3xl font-extrabold text-[#1f2a22] sm:text-4xl" data-id="element-250">
            Estómagos que ya dejaron de arder
          </h2>
        </Reveal>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-251">
          {testimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.1} data-id="element-252">
              <figure className="relative flex h-full flex-col rounded-2xl border border-[#3f6b3a]/10 bg-white p-6 shadow-sm sm:p-7" data-id="element-253">
                <span className="text-[#3f6b3a]/25" data-id="element-254">
                  <QuoteIcon className="h-9 w-9" data-id="element-255" />
                </span>
                <div className="mt-1 flex text-amber-500" aria-label="5 de 5 estrellas" data-id="element-256">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-4 w-4" data-id="element-257" />)}
                </div>
                <blockquote className="mt-3 flex-1 text-lg leading-relaxed text-[#2c3830]" data-id="element-258">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-[#3f6b3a]/10 pt-4" data-id="element-259">
                  <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#3f6b3a] font-display text-sm font-bold text-white" data-id="element-260">
                    {t.initials}
                  </span>
                  <span data-id="element-261">
                    <span className="block font-display font-bold text-[#1f2a22]" data-id="element-262">
                      {t.name}
                    </span>
                    <span className="block text-sm text-[#5a6b5c]" data-id="element-263">
                      {t.location}
                    </span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>)}
        </div>
      </div>
    </section>;
}